'use client'

import { usePathname } from 'next/navigation'
import Navigation from './navigation/page'
import Faqs from './faqs/page'
import Footer from './footer/page'

export default function SiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  if (pathname === '/') return <>{children}</>

  return (
    <>
      <Navigation />
      {children}
      <Faqs />
      <Footer />
    </>
  )
}
